import { RecordingAgentReg, RecordingAgentSettings } from '@api';
import React, { useCallback } from 'react';
import './AgentCard.scss';
import { AgentConfigurationCard } from './AgentConfigurationCard';

interface AgentProps {
	agent: RecordingAgentReg;
    onAgentChanged: (newAgent: RecordingAgentReg) => void;
}

export function AgentCard(props: AgentProps): JSX.Element {
    const {
        agent,
        onAgentChanged,
    } = props;

    const onAgentConfigChange = useCallback((newConfig: RecordingAgentSettings) => {
        onAgentChanged({...agent, ...{
            configuration: newConfig,
        } as RecordingAgentReg } as RecordingAgentReg);
    }, [agent, onAgentChanged]);

    return <div className="agent_card">
        <div className='agent_card__advanced_scroll'>
        <AgentConfigurationCard
            uniqueSuffix={`agentCard_${agent.id}`}
            configuration={agent.configuration}
            briefMode={true}
            onConfigChanged={onAgentConfigChange} />
        </div>
    </div>
}